module.exports = __webpack_public_path__ + "media/images/levelup_anim-de8ae2a5acb8099dcbb3151cb7395601.gif";